export default __webpack_public_path__ + "static/media/MarsCentra-Bold.43cc20e3.woff2";